import { func } from 'prop-types';

import { VALID, ROUTE } from 'common/const';
import { Content, Error, Form, Input, SubmitButton, TextLink } from 'common/components';
import { useCallback, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { getIsEmailRegistered } from 'data/customers';

import styles from './Signup.module.css';

const SignupCredentials = ({ onSubmit }) => {
  const [{ email, error, errorMessage }, setState] = useState({
    email: undefined,
    error: false,
    errorMessage: undefined,
  });

  const { mutateAsync, isLoading } = useMutation(({ emailAddress: email }) =>
    getIsEmailRegistered({ email }),
  );

  const checkEmail = useCallback(
    async (data) => {
      const isEmailRegistered = await mutateAsync(data);

      if (isEmailRegistered.isRegistered) {
        setState((state) => ({
          ...state,
          error: true,
          errorMessage: isEmailRegistered?.resultInformation?.displayMessage,
        }));
      } else {
        onSubmit(data);
      }
    },
    [mutateAsync, onSubmit],
  );

  return (
    <Content isLoading={isLoading}>
      {error && (
        <div className={styles.error}>
          <Error>
            {<span>{errorMessage}</span>}{' '}<TextLink to={ROUTE.LOGIN}>Log in instead</TextLink>
          </Error>
        </div>
      )}
      <Form
        validation={{
          emailAddress: VALID.EMAIL.required('Please enter a valid email.'),
        }}
        onPass={(data) => {
          setState((state) => ({ ...state, email: data.emailAddress }));
          checkEmail(data);
        }}
        onFail={(errors) => {
          // console.log(errors);
        }}
        defaultValues={{ emailAddress: email }}
      >
        <Input name="emailAddress" />

        <SubmitButton name="submit" fullWidth>
          Next
        </SubmitButton>
      </Form>
    </Content>
  );
};

SignupCredentials.propTypes = {
  onSubmit: func,
};

export default SignupCredentials;
